import { useTranslation } from 'react-i18next';
import React from 'react';
import FiltersIcon from 'assets/svgs/filterIconBlue.svg';

const Filters = ({ setShowFilters, filterOptions, selectFilter, clearFilters, isMobile }) => {
  const { t } = useTranslation();
  const isFilterChecked = filterOptions.some((item) => item.checked);
  return (
    <div>
      <div className={`roster-filters scrollable-content `}>
        <div className="filters-header">
          <div>
            <FiltersIcon className="filter-icon" />
            <div className="fw-bold filters-title">{t('rosters.filtersTitle')}</div>
          </div>

          {isFilterChecked && (
            <button className="btn-link fw-bold d-inline-block" onClick={clearFilters}>
              {t('common.labels.clear')}
            </button>
          )}

          {!isMobile && (
            <div>
              <button
                className="btn-link fw-bold d-inline-block show-desktop"
                onClick={() => {
                  setShowFilters(false);
                }}>
                {t('common.labels.hide')}
              </button>
            </div>
          )}
        </div>
        {filterOptions.map((item) => (
          <div className="filter-row" key={item.id}>
            <div>
              <input
                type="checkbox"
                name={`roster-${item.value}`}
                id={item.id}
                value={item.id}
                onChange={selectFilter}
                checked={item.checked}
              />
              <label htmlFor={item.id}>{t(item.label)}</label>
            </div>
            <div>{item.icon}</div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Filters;
